import '../../modules/mode-components';

import * as angular from 'angular';

import CreateSpaceModalController from './create-space-modal-controller';
import CREATE_SPACE_MODAL from './create-space-modal.html';
import { BugsnagHelpers } from '~/lib/bugsnag-helpers';
import { CollectionAccessLevel } from '@mode/shared/contract-common';
import { AccountFacade } from '@mode/accounts/contract';

const createSpaceDirective = function (
  Modal,
  SpaceModel,
  AlertService,
  AccountFacade: AccountFacade,
  CollectionManageAccessModalService
) {
  return {
    restrict: 'A',
    scope: {
      disableMembership: '<',
      owner: '<',
      account: '<',
      name: '@?',
      onCreate: '&',
    },
    link: function ($scope: any, elem, attrs) {
      function handleRestrictedSpace(space) {
        CollectionManageAccessModalService.manage(
          $scope.owner.username,
          space.token,
          space.default_access_level,
          space.space_type
        );

        // Navigate to the new collection before opening manage access modal.
        selectSpace(space);
      }

      function selectSpace($space) {
        // Update account collections as well after creating space.
        // This refreshes the navmenu sidebar list of collections.
        // This can move to an effect when space save actions
        // are moved to ngrx.
        AccountFacade.refreshCollections();
        if ($scope.onCreate) {
          $scope.onCreate({ $space });
        }
      }

      function saveSpace(space) {
        const params = space.toParams();
        params.includes = ['new_space_membership'];
        // TODO: Ask backend to have "default_access_level" param received as 'restricted', 'view', or 'edit'
        // so that it's the same as the edit default_access_level param value
        if (params['space.default_access_level'] === CollectionAccessLevel.Restricted) {
          params['space.default_access_level'] = 'none';
        }

        return SpaceModel.create({
          account: $scope.owner.username,
          params,
        });
      }

      function logError(err) {
        console.error(err);
        AlertService.error('Error while creating collection');
        BugsnagHelpers.notifySafely(err);
      }

      elem.on('click.context', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const modal = Modal.open(
          {
            owner: $scope.owner,
            name: $scope.name,
          },
          {
            controller: CreateSpaceModalController,
            controllerAs: 'ctrl',
            bindToController: true,
            template: CREATE_SPACE_MODAL,
            animation: true,
            backdrop: 'static',
          }
        );

        if ($scope.disableMembership) {
          modal.result.then(saveSpace).then(selectSpace).catch(logError);
        } else {
          modal.result.then(saveSpace).then(handleRestrictedSpace).catch(logError);
        }
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.context'));
    },
  };
};

createSpaceDirective.$inject = [
  'ModalService',
  'SpaceModel',
  'ToastService',
  'AccountFacade',
  'CollectionManageAccessModalService',
];

angular.module('mode.components').directive('createSpace', createSpaceDirective);
